import { render, staticRenderFns } from "./index-name.vue?vue&type=template&id=9dfd73e4&scoped=true"
import script from "./index-name.vue?vue&type=script&lang=js"
export * from "./index-name.vue?vue&type=script&lang=js"
import style0 from "./index-name.vue?vue&type=style&index=0&id=9dfd73e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dfd73e4",
  null
  
)

export default component.exports